
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logbook/[slug]",
      function () {
        return require("private-next-pages/logbook/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logbook/[slug]"])
      });
    }
  